export * from './menu-tab/menu-tab.component';
export * from './show-menu-tab.module';
